import React, { Suspense } from 'react';
import { Homepage, MainPage, ROUTES } from "./Routes";
import { Routes, Route, BrowserRouter } from "react-router-dom";
import { basename } from '~/utils/useBaseName';
import ScrollToTop from '~/utils/useScrollTop';
import { LoadingProvider } from '../providers/LoadingProviders';
import LoadingPage from '~/components/Loading';
import { PageCacheProvider } from '../providers/PageCacheContext';

function AppRoutes() {
    return (
        <BrowserRouter basename={basename}>
            <PageCacheProvider>
                <LoadingProvider>
                    <Suspense>
                        <ScrollToTop />
                        <LoadingPage />
                        <Routes>
                            <Route exact path={ROUTES.Homepage} index element={<Homepage />} />
                            <Route exact path={ROUTES.MainPage} index element={<MainPage />} />
                        </Routes>
                    </Suspense>
                </LoadingProvider>
            </PageCacheProvider>
        </BrowserRouter>
    );
}

export default AppRoutes;